export default __webpack_public_path__ + "static/media/ded-contact-other.aa4dfcf8.svg";